// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2xzyT","colMaxWidth":"Table_colMaxWidth__ga9_O"};